import { Component, OnInit } from '@angular/core';
import { ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-modal-edit-audit',
  templateUrl: './modal-edit-audit.component.html',
  providers: [DatePipe],
  styles: []
})
export class ModalEditAuditComponent extends ExcTranslation implements OnInit {
  private contactTypes: { value: number, key: string }[] = [];
  private criticals: { value: number, key: string }[] = [];
  criticID: number;
  cancelComment;
  cancelDate = new Date();
  cancelContact;
  cancelContactType;
  contacs;
  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef, private excSec: ExcSigninService, private datePipe: DatePipe) {
    super();
    const _self = this;
    const numbers = [1, 2, 3, 4, 5, 6, 8];
    for (const num of numbers) {
      _self.criticals.push({
        value: _self.getRessource('Enumeration.Critics.' + num + '.Text'),
        get key() {
          return _self.getRessource('Enumeration.Critics.' + num + '.Index');
        }
      });
    }
    const nums = [1, 2, 3, 4];
    for (const num of nums) {
      _self.contactTypes.push({
        value: _self.getRessource('Enumeration.ContactTypes.' + num + '.Text'),
        get key() {
          return _self.getRessource('Enumeration.ContactTypes.' + num + '.Index');
        }
      });
    }
  }
  ngOnInit() {
    const _self = this;
    _self.contacs = _self.overlayConfig.data.Contacs;
  }
    cancel() {
      const _self = this;
      _self.overlayRef.close({proceed: true, CancellationReason: _self.criticID, Comment: _self.generatComments()});
    }
  generatComments() {
    const _self = this;
    const obj = _self.contacs.find(x => Number(x.ContactID) === Number(_self.cancelContact));
    const cancelReason = _self.getRessource('Enumeration.Critics.' + _self.criticID + '.Text');
    const contactType = _self.getRessource('Enumeration.ContactTypes.' + _self.cancelContactType + '.Text');
    const date = _self.datePipe.transform(_self.cancelDate, _self.getGlobal('FormatDate'));
    const contactName = (obj.ContactFirstname.length > 0 ? obj.ContactFirstname + ' ' : '') + obj.ContactLastname;
    let d = _self.getRessource('CommentScheme', {
      Date: date,
      Contact: contactName,
      ContactType: contactType,
      Reason: cancelReason
    });
    if (_self.cancelComment !== null && _self.cancelComment.length > 0) {
      d = d + ': ' + _self.cancelComment;
    }
    return d;
  }
  generateContactName(data) {
   let contactName = '';
    contactName = data.ContactSalutation + ' ' + data.ContactFirstname + ' ' + data.ContactLastname;
    if (data.ContactPhone) {
      contactName = contactName + ' (' + data.ContactPhone + ')' ;
    }
   return contactName;
  }
}
